import { heroContent } from '@/mocks/content';
import { mainSiteUrl } from '@/mocks/categories';

export default function HeroSection() {
  return (
    <section className="relative w-full min-h-[600px] md:min-h-[700px] flex items-center overflow-hidden">
      <img
        src="https://readdy.ai/api/search-image?query=Dark%20moody%20fashion%20product%20flatlay%20overhead%20shot%20with%20sneakers%20leather%20wallet%20and%20sunglasses%20on%20deep%20charcoal%20surface%20dramatic%20studio%20lighting%20high%20contrast%20editorial%20luxury%20aesthetic%20warm%20amber%20highlights&width=1800&height=900&seq=hero-v3-main&orientation=landscape"
        alt="Itaobuy Spreadsheet prodotti moda"
        className="absolute inset-0 w-full h-full object-cover object-center"
      />
      <div className="absolute inset-0 bg-gradient-to-b from-black/55 via-black/35 to-black/65"></div>
      <div className="absolute inset-0 bg-black/20"></div>

      <div className="relative z-10 w-full px-4 md:px-6 lg:px-10 py-20 md:py-28">
        <div className="max-w-2xl">
          <h1 className="text-2xl sm:text-3xl md:text-5xl lg:text-[56px] font-heading font-bold text-white leading-[1.12] tracking-tight mb-5 md:mb-6"
            style={{ textShadow: '0 2px 12px rgba(0,0,0,0.45)' }}
          >
            Itaobuy Spreadsheet Italia:
            <br />
            <span className="text-white/85 font-normal">Trova i migliori prodotti cinesi in modo semplice e intelligente</span>
          </h1>

          <p className="text-sm md:text-base text-white/80 max-w-lg leading-relaxed mb-8 md:mb-10 font-light"
            style={{ textShadow: '0 1px 6px rgba(0,0,0,0.4)' }}
          >
            {heroContent.subtitle}
          </p>

          <div className="flex flex-col sm:flex-row items-start gap-3.5 mb-10">
            <a
              href={mainSiteUrl}
              target="_blank"
              rel="noopener nofollow"
              className="inline-flex items-center gap-2 px-7 py-3.5 rounded-full bg-primary-500 text-white text-sm md:text-base font-semibold whitespace-nowrap cursor-pointer hover:bg-primary-600 transition-all duration-300"
            >
              Scopri Itaobuy Spreadsheet
              <i className="ri-arrow-right-line text-lg"></i>
            </a>
            <a
              href={mainSiteUrl}
              target="_blank"
              rel="noopener nofollow"
              className="inline-flex items-center gap-2 px-7 py-3.5 rounded-full border border-white/30 text-white text-sm md:text-base font-medium whitespace-nowrap cursor-pointer hover:bg-white/10 transition-all duration-300"
            >
              Itaobuy Sheet
            </a>
          </div>

          <div className="flex flex-wrap items-center gap-3 md:gap-4">
            {heroContent.trustBadges.map((badge, i) => (
              <span
                key={i}
                className="inline-flex items-center gap-1.5 text-xs md:text-sm text-white/90 font-medium"
              >
                <i className="ri-checkbox-circle-fill text-accent-400 text-sm"></i>
                {badge}
              </span>
            ))}
          </div>
        </div>
      </div>

      <div className="absolute bottom-6 left-1/2 -translate-x-1/2 z-10">
        <div className="w-5 h-8 rounded-full border border-white/30 flex items-start justify-center pt-1.5">
          <div className="w-1 h-2 rounded-full bg-white/70 animate-bounce"></div>
        </div>
      </div>
    </section>
  );
}